export default [
    `最优价<br/>Best Available Rate`,
    "包价和促销<br/>Package & Promotion",
    "电子商务<br/>E-Commerce",
    "旅游批发商<br/>Wholesale (traditional+online WHL)",
    "公司协议价<br/>Corporate Negotiate (local+national)",
    "政府价<br/>Government",
    "折扣和奖励<br/>Discount & Award",
    "商务团队<br/>Business Group (MICE+Gov)",
    `休闲团队<br/>Leisure Group (Series+One-time)`,
    `合同<br/>Contracts (long-stay+crew+layover)`,
    `Total`
].map((name, i) => ({
    name,
    key: name,
    sort: i,
    otb: 0,
    trend: 0,
    forecast: 0,
    budget: 0,
    plans: '',
    strategy: ""
})) 


// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.2/data.js